export default __webpack_public_path__ + "static/media/2.d0c165e7.png";